import { Checkbox } from "@shopify/polaris";
import React from "react";

export default function CaAb1263Required({ checked, setChecked, label, price }) {
  const displayPrice = price !== undefined ? price : 0.35;
  const isFree = displayPrice === 0;

  return (
    <div className="ri-p-5">
      <svg
        height="40px"
        width="40px"
        fill="#6B7280"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className="ri-w-10 ri-h-10 ri-fill-current ri-text-gray-600"
        style={{ marginBottom: "1rem" }}
      >
        <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
      </svg>

      <h2 className="ri-text-lg ri-font-semibold ri-text-gray-700">
        California AB 1263 Acknowledgment
      </h2>
      <p className="ri-text-gray-600 ri-text-base ri-max-w-md ri-mb-4">
        Require customers to acknowledge the California AB 1263 firearm
        precursors notice before ID verification.
      </p>

      <Checkbox
        label={label || "Require California AB 1263 acknowledgment"}
        checked={checked}
        onChange={setChecked}
        helpText={
          isFree ? (
            <p className="ri-text-gray-600">No additional cost</p>
          ) : (
            <p className="ri-text-gray-600">+${displayPrice.toFixed(2)} per check</p>
          )
        }
      />
    </div>
  );
}
